import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  AdaptiveAccessControlNode} from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../ada-access-api-endpoints';

interface GetRulesResponse {
  adaptiveaccesscontrolnodes: AdaptiveAccessControlNode[];
}

interface GetRuleResponse {
    adaptiveaccesscontrolnode: AdaptiveAccessControlNode;
}

@Injectable({
  providedIn: 'root'
})
export class AdaptiveAccessNodeService {
  private readonly adadptiveAccessNodeUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

  getAdaptiveAccessNodes(currentPage: number): Observable<AdaptiveAccessControlNode[]> {
    return this.http.post<GetRulesResponse>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.FETCH}`, { currentPage })
      .pipe(
        map(response => response.adaptiveaccesscontrolnodes),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getAllAdaptiveAccessNodes(): Observable<AdaptiveAccessControlNode[]> {
    return this.http.post<GetRulesResponse>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.GETNODES}`, {  })
      .pipe(
        map(response => response.adaptiveaccesscontrolnodes),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getAdaptiveAccessNodesSearch(currentPage: number , searchText: String, filterByHeader:String): Observable<AdaptiveAccessControlNode[]> {
    return this.http.post<GetRulesResponse>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.SEARCH}`, { currentPage, searchText, filterByHeader })
      .pipe(
        map(response => response.adaptiveaccesscontrolnodes),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getAdaptiveAccessNode(adaptiveaccessnodeid: string): Observable<AdaptiveAccessControlNode> {
    return this.http.post<GetRuleResponse>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.GET}`, { adaptiveaccessnodeid })
      .pipe(
        map(response => response.adaptiveaccesscontrolnode),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }
   

  createadaptiveaccessnodes(
    adaptiveAccessNodeName: string,
    adaptiveAccessNodeType: string,
    organizationId: string,
    authenticationProtocol: string,
    authenticationEndpoint: string
  ): Observable<AdaptiveAccessControlNode> {
    return this.http.post<AdaptiveAccessControlNode>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.CREATE}`, {
        // adaptiveAccessNodeId,
        adaptiveAccessNodeName,
        adaptiveAccessNodeType,
        organizationId,
        authenticationProtocol,
        authenticationEndpoint
    }).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  updateadaptiveaccessnodes(
    adaptiveAccessNodeId: string,
    adaptiveAccessNodeName: string,
    adaptiveAccessNodeType: string,
    organizationId: string,
    authenticationProtocol: string,
    authenticationEndpoint: string
  ): Observable<AdaptiveAccessControlNode> {
    return this.http.post<AdaptiveAccessControlNode>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.UPDATE}`, {
        adaptiveAccessNodeId,
        adaptiveAccessNodeName,
        adaptiveAccessNodeType,
        organizationId,
        authenticationProtocol,
        authenticationEndpoint
    }).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  finishProcess(): Observable<AdaptiveAccessControlNode>{
    return this.http.post<AdaptiveAccessControlNode>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.FINISH}`, {
  }).pipe(
    catchError(error => this.errorHandlingService.handleError(error))
  );
  }

  deleteadaptiveaccessnodes(adaptiveaccessnodeid: string): Observable<AdaptiveAccessControlNode> {
    return this.http.post<AdaptiveAccessControlNode>(`${this.adadptiveAccessNodeUrl}${API_ENDPOINTS.ADAPTIVEACCESSCONTROLNODE.DELETE}`, { adaptiveaccessnodeid })
      .pipe(
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }
}